import { createContext, type PropsWithChildren, useContext } from 'react'
import { type StellaSession, useStellaSession } from '@/hooks/useStellaSession'

const StellaProviderContext = createContext<StellaSession | null>(null)

export const StellaProvider = ({ children }: PropsWithChildren) => {
  const session = useStellaSession({})

  return (
    <StellaProviderContext.Provider value={session}>
      {children}
    </StellaProviderContext.Provider>
  )
}

export const useStella = () => {
  const context = useContext(StellaProviderContext)

  if (context === null) {
    throw new Error('useStella must be used within a StellaProvider')
  }

  return context
}
